var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('header-info',{attrs:{"activeName":"/home"}}),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"move","mode":"out-in"}},[_c('router-view')],1)],1),_c('footer-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }